import styled from 'styled-components';

import { WrapperProps } from './types';

export const FieldTextareaComponent = styled.section`
  /* Use correct HTML element! */
`;
export const Wrapper = styled.div<WrapperProps>`
  textarea {
    width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
    height: 122px;
    resize: none;
    border: 1px solid ${({ theme }) => theme?.colours?.charcoalDust};
    border-radius: 5px;
    font-size: ${({ theme }) => theme.spacing(14)};
    line-height: ${({ theme }) => theme.spacing(22)};
    padding: ${({ theme }) => theme.spacing({ left: 20, top: 15, right: 20, bottom: 15 })};
  }

  input {
    width: 100%;
    border: 1px solid ${({ theme }) => theme?.colours?.charcoalDust};
    border-radius: 5px;
    font-size: ${({ theme }) => theme.spacing(14)};
    line-height: ${({ theme }) => theme.spacing(22)};
    padding: ${({ theme }) => theme.spacing({ left: 20, top: 15, right: 20, bottom: 15 })};
  }

  &.invalid {
    textarea {
      border: 1px solid ${({ theme }) => theme?.colours?.redRampage};
      background: rgb(239 56 38 / 25%);
      outline: 1px solid ${({ theme }) => theme?.colours?.redRampage};
    }
  }

  &.valid {
    textarea {
      border: 1px solid ${({ theme }) => theme?.colours?.charcoalDust};
      outline: none;
    }
  }

  &:not(.invalid) textarea:focus-visible {
    border: 1px solid ${({ theme }) => theme.colours.swimmersPool};
    background-color: #f6fdfc;
    outline: none;
  }
`;
